import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
    name: 'company',
    initialState: {
        isRequesting: false,
        error: null,
        isDone: false,
        data: null,
    },
    reducers: {
        create_company: (state) => {
            return {
                ...state,
                isRequesting: true,
                isDone: false,
                error: null,
            };
        },
        delete_company: (state) =>{
            return {
                ...state,
                isRequesting: true,
                isDone: false,
                error: null,
            };
        },
        update_company: (state) =>{
            return {
                ...state,
                isRequesting: true,
                isDone: false,
                error: null,
            };
        },
        assign_admin_company: (state) =>{
            return {
                ...state,
                isRequesting: true,
                isDone: false,
                error: null,
            };
        },
        delete_company_failed: (state,action) =>{
            return {
                ...state,
                isRequesting: false,
                isDone: true,
                error: action.payload,
                data: null
            };
        },
        update_company_failed: (state,action) =>{
            return {
                ...state,
                isRequesting: false,
                isDone: true,
                error: action.payload,
                data: null
            };
        },
        assign_admin_company_failed: (state,action) =>{
            return {
                ...state,
                isRequesting: false,
                isDone: true,
                error: action.payload,
                data: null
            };
        },
        create_company_failed: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                isDone: true,
                error: action.payload,
                data: null
            };
        },
        delete_company_succeed: (state) =>{
            return {
                ...state,
                isRequesting: false,
                error: null,
                isDone: true,
            };
        },
        assign_admin_company_succeed: (state) =>{
            return {
                ...state,
                isRequesting: false,
                error: null,
                isDone: true,
            };
        },
        update_company_succeed: (state) =>{
            return {
                ...state,
                isRequesting: false,
                error: null,
                isDone: true,
            };
        },
        create_company_succeed: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                error: null,
                isDone: true,
                data: action.payload
            };
        },
       
    }
});

export const { reducer, actions } = slice;

export default reducer;